import styled from 'styled-components';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth, Text, units } from '@calm-web/design-system';

export const ErrorHeader = styled.h4`
	margin-top: 0;
	${fontWeight(FontWeights.Light)};

	${minWidth('desktop')} {
		margin: 0;
	}
`;

export const StyledText = styled(Text)`
	${fontSize(FontSizes.base)};
`;

export const ErrorSupport = styled.div`
	margin-top: 24px;
	a {
		text-decoration: underline;
		${fontWeight(FontWeights.Medium)};
	}
`;

export const PaddedTop = styled.div`
	margin-top: 24px;
`;

export const MaxSubscriptionHeader = styled.div`
	${fontSize(FontSizes.lg)};
	${fontWeight(FontWeights.Medium)};
	padding-bottom: ${units(1)};
`;

export const CustomSSOLink = styled.div`
	margin-top: 36px;
`;
